import React, { useState } from "react"
import { ChevronDown, ChevronRight } from "lucide-react"

export default function CustomAccordion({ title, children, defaultOpen = false }: { title: string; children: React.ReactNode; defaultOpen?: boolean }) {
  const [open, setOpen] = useState(defaultOpen)
  return (
    <div className="w-full mb-2">
      <div className="flex items-center cursor-pointer select-none" onClick={() => setOpen((v) => !v)}>
        <div className="flex items-center bg-gray-100 rounded-md px-2 py-1 text-xs font-medium text-gray-700 border border-gray-300">
          {title}
        </div>
        <div className="flex-1 border-t border-gray-200 mx-2" />
        <span className="text-gray-400">
          {open ? <ChevronDown className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}
        </span>
      </div>
      {open && <div className="pl-6 py-2 flex flex-col gap-4">{children}</div>}
    </div>
  )
}

